<template>
  <div>
    <v-timeline :align-top="false" :dense="true" :reverse="false" class="custom">
      <transition-group name="list">
        <component v-for="log in items" :is="log.type" :key="log._id" :record="log" :parentType="parentType" :storeKey="storeKey" @hideLog="hideLog"/>
      </transition-group>
    </v-timeline>
   

  </div>
</template>

<script>
import newImage from "./timelineItems/newImage.vue";
import description from "./timelineItems/editDescription.vue";
import deleteImage from "./timelineItems/deleteImage.vue";
import disabled from "./timelineItems/disabled.vue";
import enabled from "./timelineItems/enabled.vue";
import created from "./timelineItems/created.vue";
import message from "./timelineItems/message.vue";
import deleteCheckList from "./timelineItems/deleteCheckList.vue";
import addCheckList from "./timelineItems/addCheckList.vue";
export default {
  name: "Timeline",
  components: {
    newImage,
    description,
    deleteImage,
    disabled,
    enabled,
    created,
    message,
    deleteCheckList,
    addCheckList
  },
  props: { items: Array, parentType: String, storeKey: String },
  data() {
    return {
    };
  },
  watch: {
    items: function() {
    }
  },
  methods: {
    hideLog(data){
      this.$emit("hideLog", data)
    }
  },
  mounted() {}
};
</script>

<style>
</style>